import { useState } from 'react'

import { F0Box } from '@factorialco/f0-react'
import { Tabs } from '@factorialco/f0-react/dist/experimental'
import {
  FinanceBudgetsDetailBudgetFragment,
  FinanceBudgetsBudgetAmountWidgetsFragment
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import { BudgetAmountWidgets } from 'modules/finance/components/Budgets/BudgetDetailDataCollection/AmountWidgets'

import { RecordsDataCollection } from './RecordsDataCollection'
import { EmployeesDataCollection } from './EmployeesDataCollection'

const TAB_IDS = {
  RECORDS: 'records',
  EMPLOYEES: 'employees'
} as const

interface Props {
  budget: FinanceBudgetsDetailBudgetFragment
  amounts: FinanceBudgetsBudgetAmountWidgetsFragment
}

export const ExpenseBudgetDetailDataCollection = ({ budget, amounts }: Props) => {
  const [activeTab, setActiveTab] = useState<string>(TAB_IDS.RECORDS)
  const {
    access: { locale }
  } = useCurrentSession()

  return (
    <F0Box display="flex" flexDirection="column" gap="xl">
      <BudgetAmountWidgets budget={budget} initialAmounts={amounts} />
      <Tabs
        activeTabId={activeTab}
        setActiveTabId={setActiveTab}
        tabs={[
          {
            id: TAB_IDS.RECORDS,
            label: i18n.t('budgets.expense_budget_detail.tabs.records')
          },
          {
            id: TAB_IDS.EMPLOYEES,
            label: i18n.t('budgets.expense_budget_detail.tabs.employees')
          }
        ]}
      />
      {activeTab === TAB_IDS.RECORDS && <RecordsDataCollection budget={budget} locale={locale} />}
      {activeTab === TAB_IDS.EMPLOYEES && (
        <EmployeesDataCollection budget={budget} locale={locale} />
      )}
    </F0Box>
  )
}
